/**
 * Recommendation rail analytics (Milestone 13 / M15).
 */
import { trackBuyerEvent } from "./buyerAnalytics";
import { RECOMMENDATION_ANALYTICS_EVENTS } from "../constants/automapVehicleRecommendationConstants";

export { RECOMMENDATION_ANALYTICS_EVENTS };

export function buildRecommendationAnalyticsPayload(sourceListing, recommendedListing, extra = {}) {
  return {
    sourceListingId: sourceListing?.id || null,
    sourceListingSlug: sourceListing?.slug || sourceListing?.id || null,
    recommendedListingId: recommendedListing?.id || null,
    recommendedListingSlug: recommendedListing?.slug || recommendedListing?.id || null,
    dealerId: recommendedListing?.dealerId || sourceListing?.dealerId || null,
    city: recommendedListing?.city || sourceListing?.city || null,
    make: recommendedListing?.make || sourceListing?.make || null,
    model: recommendedListing?.model || sourceListing?.model || null,
    bodyType: recommendedListing?.bodyType || sourceListing?.bodyType || null,
    priceCop: recommendedListing?.priceCop ?? sourceListing?.priceCop ?? null,
    sourcePage: extra.sourcePage || "vehicle_detail",
    sourceComponent: extra.sourceComponent || "vehicle_recommendation_rail",
    ...extra,
  };
}

export function trackRecommendationEvent(eventType, sourceListing, recommendedListing, extra = {}) {
  trackBuyerEvent(eventType, buildRecommendationAnalyticsPayload(sourceListing, recommendedListing, extra));
}
